import {IControlRatioStatisticDto, IDocumentLookups} from '../model/types';

/**
 * Получает значение из списка `documentLookups` по заданному `lookupCode`.
 *
 * Функция ищет в массиве `documentLookups` объект, чей `lookupCode` совпадает
 * с `lookupCode` из `docName` в переданной строке данных (`row`).
 * Если такой объект найден, возвращается его значение по указанному ключу `key`.
 *
 * @template K - Ключ одного из свойств `DocumentLookups`, которое требуется получить.
 * @param {IControlRatioStatisticDto} row - Объект строки данных, содержащий `documentLookups`.
 * @param {K} key - Ключ свойства, значение которого необходимо извлечь.
 * @returns {IDocumentLookups[K] | undefined} - Значение, найденное в `documentLookups`,
 * либо `undefined`, если соответствующий объект не найден.
 */
export const getLookupValue = <K extends keyof IDocumentLookups>(
    row: IControlRatioStatisticDto,
    key: K,
): IDocumentLookups[K] | undefined => (
        row.documentLookups.find(e => e.lookupCode === row.document.lookupCode)?.[key]
    );
